import React from "react";
import "./Game_History.css";
import CustomPagination from "../../../Common/Common_Component/CustomPagination/CustomPagination";

function Game_History() {
  const gameData = [
    { period: "123456789012", number: 1, size: "Small", color: ["green"] },
    { period: "123456789012", number: 2, size: "Small", color: ["red"] },
    { period: "123456789012", number: 4, size: "Small", color: ["red"] },
    {
      period: "123456789012",
      number: 5,
      size: "Big",
      color: ["green", "purple"],
    },
    { period: "123456789012", number: 7, size: "Big", color: ["green"] },
    { period: "123456789012", number: 9, size: "Big", color: ["green"] },
    { period: "123456789012", number: 6, size: "Big", color: ["red"] },
    { period: "123456789012", number: 8, size: "Big", color: ["red"] },
    {
      period: "123456789012",
      number: 0,
      size: "Small",
      color: ["red", "purple"],
    },
    { period: "123456789012", number: 9, size: "Big", color: ["green"] },
  ];

  return (
    <>
      <section className="Game_History">
        <div className="table_wrapper">
          <table>
            <thead>
              <tr>
                <th>Period</th>
                <th>Number</th>
                <th>Big / Small</th>
                <th>Color</th>
              </tr>
            </thead>

            <tbody>
              {gameData.map((item, index) => (
                <tr key={index}>
                  <td>{item.period}</td>

                  <td className={`number ${item.color[0]}`}>{item.number}</td>

                  <td>{item.size}</td>

                  <td>
                    <div className="color_dots">
                      {item.color.map((clr, i) => (
                        <span key={i} className={`dot ${clr}`}></span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <CustomPagination/>
    </>
  );
}

export default Game_History;
